import { useTranslation } from "react-i18next";
import { Grid, GridColumn } from "semantic-ui-react";

import { DealersAndLocationsDropdown, Dropdown, ExportDataButton, NavPortal, ResetFiltersButton, SearchFilter } from "components";
import "modules/DevicesDashboard/components/DevicesDashboardFilters/DevicesDashboardFilters.scss";
import { useBrandsQuery, useExportDevicesMutation, useModelsQuery, useOsVersionsQuery } from "modules/DevicesDashboard/components/DevicesDashboardFilters/hooks";
import { DEFAULT_DEVICE_FILTERS, setDevicesFilters, useDevicesFilters } from "modules/DevicesDashboard/components/DevicesDashboardFilters/hooks/useDeviceFilters";

const SEARCH_MIN_LENGTH = 4;
const SEARCH_DEBOUNCE_TIME = 300;

export const DevicesDashboardFilters = () => {
  const { t } = useTranslation();

  const { data: brandOptions = [] } = useBrandsQuery();
  const { data: modelOptions = [] } = useModelsQuery();
  const { data: osVersionOptions = [] } = useOsVersionsQuery();
  const { mutate: exportDevices, isPending: isExportPending } = useExportDevicesMutation();

  const filters = useDevicesFilters();
  const { dealer_ids, dealer_location_ids, brands, models, os_versions, search_term } = filters;

  const onSearchChange = (value: string) => {
    if (value.length > 0 && value.length < SEARCH_MIN_LENGTH) return;
    setDevicesFilters({ search_term: value, page: 1 });
  };

  return (
    <div className="DevicesDashboardFilters">
      <NavPortal>
        <SearchFilter value={search_term} debounceTime={SEARCH_DEBOUNCE_TIME} handleSearchChange={onSearchChange} />
      </NavPortal>
      <div className="toolbar-container">
        <Grid columns="equal" className="toolbar-grid">
          <GridColumn>
            <DealersAndLocationsDropdown
              values={{ dealerIds: dealer_ids, locationIds: dealer_location_ids }}
              handleOnChange={({ dealerIds, locationIds }) => setDevicesFilters({ dealer_ids: dealerIds, dealer_location_ids: locationIds, page: 1 })}
              allowSelectAllDealers={false}
            />
          </GridColumn>
          <GridColumn>
            <Dropdown
              fluid
              multiple
              search
              selection
              clearable
              selectOnBlur={false}
              value={brands}
              options={brandOptions}
              placeholder={t("v8_select_brand_s", "Select Brand(s)")}
              onChange={brands => setDevicesFilters({ brands, page: 1 })}
            />
          </GridColumn>
          <GridColumn>
            <Dropdown
              fluid
              multiple
              search
              selection
              clearable
              selectOnBlur={false}
              value={models}
              options={modelOptions}
              placeholder={t("v8_select_model_s", "Select Model(s)")}
              onChange={models => setDevicesFilters({ models, page: 1 })}
            />
          </GridColumn>
          <GridColumn>
            <Dropdown
              fluid
              multiple
              search
              selection
              clearable
              selectOnBlur={false}
              value={os_versions}
              options={osVersionOptions}
              placeholder={t("v8_select_os_version_s", "Select OS Version(s)")}
              onChange={os_versions => setDevicesFilters({ os_versions, page: 1 })}
            />
          </GridColumn>
        </Grid>
        <div className="toolbar-export">
          <ResetFiltersButton handleReset={() => setDevicesFilters(DEFAULT_DEVICE_FILTERS)} />
          <ExportDataButton disabled={isExportPending} handleOnClick={() => exportDevices(filters)} />
        </div>
      </div>
    </div>
  );
};
